import { render, staticRenderFns } from "./DocComptabilite.vue?vue&type=template&id=9f15f1e6&"
import script from "./DocComptabilite.vue?vue&type=script&lang=js&"
export * from "./DocComptabilite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports